// Libraries
import { Center, CenterProps } from '@chakra-ui/react';
// Resources
import bg from '@assets/images/bg.webp';

/**
 * A reusable background component for authentication pages.
 *
 * @component
 * @param {CenterProps} props - The props for the AuthBackground component.
 * @returns {ReactElement} The rendered AuthBackground component.
 */
export const AuthBackground = (props: CenterProps) => {
  const { children, ...rest } = props;

  const bgImage = `linear-gradient(14deg, rgba(3, 30, 41, 0.6) 14%, rgba(0, 0, 0, 0.5) 102%), url('${bg.src ?? bg}')`;

  return (
    <Center flex={1} p={0} bgImage={bgImage} bgRepeat='no-repeat' bgSize='cover' {...rest}>
      {children}
    </Center>
  );
};
